import { createSlice } from "@reduxjs/toolkit";
import {
  EditPermissionRole,
  GetAllPermissionType,
  GetAllRoleType,
} from "./UserPermissionApi";

const roleSlice = createSlice({
  name: "role",
  initialState: {
    allRolesType: [],
    allPermissionType: [],
    allPermissionUser: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllRoleType.fulfilled, (state, action) => {
        state.allRolesType = action.payload?.data?.roletype_name;
      })
      .addCase(GetAllPermissionType.fulfilled, (state, action) => {
        state.allPermissionType = action?.payload?.data?.roles_management;
      });
  },
});

export const {} = roleSlice.actions;

export default roleSlice.reducer;
/// content: '└─';
